<template>
  <div class="b-movie-search-result-mobile">
    <div class="b-movie-card__wrapper">
      <a :href="movieUrl" class="b-movie-card__wrapper__img">
        <img :src="image" alt="" />
      </a>
    </div>
    <div class="b-movie-card__content">
      <div class="b-movie-card__translate-label">
        <div v-if="translated" class="e-label e-label--translated">
          {{ translatableText }}
        </div>
      </div>
      <a :href="movieUrl" class="b-movie-card__content-holder">
        <div class="b-movie-card__title-holder">
          <div class="b-movie-card__title">
            {{ title }}
          </div>
          <div class="b-movie-card__subtitle">
            {{ subTitle }}
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    translated: { default: false, type: Boolean },
    translatableText: { default: '', type: String },
    movieUrl: { default: '', type: String },
    title: { default: '', type: String },
    subTitle: { default: '', type: String },
    image: { default: '', type: String },
  },
}
</script>
